import { Tldraw } from 'tldraw'
import 'tldraw/tldraw.css'
import { useState, useEffect } from 'react'
import { useSupabaseSync } from './hooks/useSupabaseSync'

// 生成或获取房间ID
function getRoomId(): string {
  const params = new URLSearchParams(window.location.search)
  let roomId = params.get('room')
  
  if (!roomId) {
    roomId = Math.random().toString(36).substring(2, 15)
    const newUrl = `${window.location.pathname}?room=${roomId}`
    window.history.replaceState({}, '', newUrl)
  }
  
  return roomId
}

function App() {
  const [roomId, setRoomId] = useState<string>('')
  const [showRoomInfo, setShowRoomInfo] = useState(true)
  
  useEffect(() => {
    setRoomId(getRoomId())
  }, [])

  // 使用 Supabase 同步
  const { store, isConnected, isLoading, error, userId } = useSupabaseSync(roomId)

  const copyRoomLink = () => {
    const url = `${window.location.origin}${window.location.pathname}?room=${roomId}`
    navigator.clipboard.writeText(url)
    alert('房间链接已复制到剪贴板！')
  }

  const createNewRoom = () => {
    const newRoomId = Math.random().toString(36).substring(2, 15)
    const newUrl = `${window.location.pathname}?room=${newRoomId}`
    window.location.href = newUrl
  }

  const retryConnection = () => {
    window.location.reload()
  }

  if (!roomId || isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '16px'
      }}>
        正在连接 Supabase 数据库...
      </div>
    )
  }

  return (
    <div style={{ position: 'fixed', inset: 0 }}>
      {showRoomInfo && (
        <div style={{
          position: 'absolute',
          top: 10,
          left: 10,
          zIndex: 1000,
          background: 'white',
          padding: '12px',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          fontSize: '14px',
          maxWidth: '320px',
          border: !isConnected ? '2px solid #ffc107' : '2px solid #28a745'
        }}>
          <div style={{ marginBottom: '8px' }}>
            <strong>
              {isConnected ? '🌐 Supabase 实时协作' : '⚠️ 连接中断'}
            </strong>
            <button 
              onClick={() => setShowRoomInfo(false)}
              style={{ 
                float: 'right', 
                background: 'none', 
                border: 'none', 
                cursor: 'pointer',
                fontSize: '18px',
                lineHeight: 1
              }}
            >
              ×
            </button>
          </div>
          
          {error && (
            <div style={{ 
              marginBottom: '8px', 
              fontSize: '12px', 
              color: '#856404',
              padding: '6px',
              background: '#fff3cd',
              borderRadius: '4px',
              border: '1px solid #ffeaa7'
            }}>
              ℹ️ {error}
            </div>
          )}
          
          <div style={{ marginBottom: '10px', fontSize: '12px', color: '#666' }}>
            {isConnected 
              ? `房间ID: ${roomId} | 用户: ${userId.substring(0, 6)}...` 
              : '连接已断开 - 数据可能不同步'
            }
          </div>
          
          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
            {isConnected && (
              <button 
                onClick={copyRoomLink}
                style={{
                  padding: '6px 10px',
                  fontSize: '12px',
                  background: '#007bff',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                📋 复制链接
              </button>
            )}
            
            <button 
              onClick={createNewRoom}
              style={{
                padding: '6px 10px',
                fontSize: '12px',
                background: '#28a745',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              ➕ 新建房间
            </button>
            
            {!isConnected && (
              <button 
                onClick={retryConnection}
                style={{
                  padding: '6px 10px',
                  fontSize: '12px',
                  background: '#ffc107',
                  color: '#212529',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                🔗 重新连接
              </button>
            )}
          </div>
        </div>
      )}
      
      <Tldraw 
        store={store}
        deepLinks 
        inferDarkMode
      />
    </div>
  )
}

export default App 